import { marked } from 'marked';
import React from 'react';
import i18next from 'i18next';
import { CMSBreadcrumb } from '../../Components/Search/SearchModels';

import {
  Wrapper,
  ImageWrapper,
  Image,
  ContentWrapper,
  Breadcrumb,
  Heading,
  Preamble,
} from './wrapper';

interface Props {
  image?: string;
  image2x?: string;
  heading: string;
  preamble?: string[];
  link?: string;
  breadcrumb?: CMSBreadcrumb[];
}

const ContentCard = ({ image, image2x, breadcrumb, heading, preamble, link }: Props) => {
  const formattedBreadcrumb = breadcrumb?.slice(-1).pop()?.name;

  const __html = preamble
    ? (
        marked.parse(preamble.sort((a, b) => b.length - a.length)?.[0] || '', {
          async: false,
        }) as string
      )
        .replace(/<\/?(?=\w)(?!em).*?>/g, '')
        .replace(/<em>/gi, '<em class="font-bold">')
        .replace(/\**/gi, '')
    : undefined;

  return (
    <Wrapper>
      <ImageWrapper>
        {image && (
          <Image src={image} srcSet={image2x ? `${image2x} 2x` : undefined} alt={heading} />
        )}
      </ImageWrapper>
      <ContentWrapper>
        {formattedBreadcrumb && <Breadcrumb>{formattedBreadcrumb}</Breadcrumb>}
        <Heading
          as={link ? 'a' : undefined}
          href={link ? link : undefined}
          title={link ? i18next.t('other.goToHeading', { heading }) || '' : undefined}
        >
          {heading}
        </Heading>
        {__html && (
          <Preamble
            dangerouslySetInnerHTML={{
              __html,
            }}
          />
        )}
      </ContentWrapper>
    </Wrapper>
  );
};

export default ContentCard;
